// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"3c2d98ce","453":"8aa89ac1"}[chunkId] + ".chunk.js";
};